import {post} from "../../../api/api";

export function getUrlBase() {
  let {subDomain} = document.kvConfig;
  let {domain} = document.kvConfig;
  domain = domain || 'quotesflooring.com';
  subDomain = subDomain ? subDomain + '.' : '';

  return (location.port === "9007" || document.kvConfig.kioskMode) ? `${subDomain}${domain}` : "";
}

export const sqftPost = async (url, data) => {
  return post(url, data);
};
